import { ConnectorDTO } from '../DTOs/ConnectorDTO';
import { AttributePair } from './Product';
import { IdMapper, ProductBlueprint } from './ProductBlueprint';
import { TransformationData } from './TransformationData';

export class Connector {
  public static fromDTO(connectorDTO: ConnectorDTO) {
    return new Connector(
      connectorDTO.productBlueprintId.toString(),
      TransformationData.fromDTO(connectorDTO.transformationData),
    );
  }

  private _productBlueprint?: ProductBlueprint;
  private _productBlueprintId: string;
  private _transformationData: TransformationData;
  private _overrideAttributes: AttributePair[] = [];

  public get productBlueprint() {
    return this._productBlueprint;
  }

  public get transformationData() {
    return this._transformationData;
  }

  public get overrideAttributes() {
    return this._overrideAttributes;
  }

  constructor(
    productBlueprintId: string,
    transformationData: TransformationData,
    productBlueprint?: ProductBlueprint,
    overrideAttributes: AttributePair[] = [],
  ) {
    this._productBlueprintId = productBlueprintId;
    this._transformationData = transformationData;
    this._productBlueprint = productBlueprint;
    this._overrideAttributes = overrideAttributes;
  }

  public populateProductBlueprintReferences(availibleBlueprints: ProductBlueprint[], idMapper: IdMapper) {
    let foundProductBlueprint = idMapper.productBlueprintMap.get(this._productBlueprintId);

    if (!foundProductBlueprint) {
      foundProductBlueprint = availibleBlueprints.find(
        (productBlueprint) => productBlueprint.id === this._productBlueprintId,
      );
    }

    if (foundProductBlueprint) idMapper.productBlueprintMap.set(this._productBlueprintId, foundProductBlueprint);

    if (!foundProductBlueprint) {
      throw new Error('Could not populate product relationship, because blueprint was not in availible blueprints');
    }

    this._productBlueprint = foundProductBlueprint;
  }
}
